import React, { useState, useEffect } from "react";
import "../styles/Navbar.css";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import ListItemIcon from "@mui/material/ListItemIcon";

import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import LogoutIcon from "@mui/icons-material/Logout";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MenuIcon from "@mui/icons-material/Menu";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import Badge from "@mui/material/Badge";
import profilePlaceholder from "../Images/profile.svg";

import { useNavigate } from "react-router-dom";
import { startSession } from "../Utils/SessionManager";

function Navbar({ sidebarCollapsed, onSidebarToggle }) {
  const [buttonText, setButtonText] = useState("");
  const [userName, setUserName] = useState("");
  //new 21

  const [profileImage, setProfileImage] = useState(
    sessionStorage.getItem("profileImage") || profilePlaceholder,
  );

  // useEffect(() => {
  //   debugger;
  //   if(sessionStorage.getItem("Source")==="ERP"){
  //     setButtonText("Go to Home");
  //     setUserName(sessionStorage.getItem("empname"));
  //  }
  //  else{
  //     setButtonText("Logout");
  //     setUserName(sessionStorage.getItem("empname"));
  //  }
  // });

  //new 21

  useEffect(() => {
    const source = sessionStorage.getItem("Source");

    if (source === "ERP") {
      setButtonText("Go to Home");
    } else {
      setButtonText("Logout");
    }

    setUserName(sessionStorage.getItem("empname") || "User");
    // Start session
    startSession();
  }, []);

  //new 21

  const getInitials = (name) => {
    if (!name || !name.trim()) {
      return "U";
    }

    return name
      .trim()
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase())
      .join("");
  };

  const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const formattedDate = new Date().toLocaleDateString('en-GB', dateOptions);

  const navigate = useNavigate();
  // const userName =
  // sessionStorage.getItem("empname") || "User";

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // const handleLogout = () => {
  //   sessionStorage.clear();
  //   navigate("/login");
  // };

  const handleLogout = () => {
    localStorage.removeItem("vmsSession");

    localStorage.removeItem("vmsSessionData");
    if (sessionStorage.getItem("Source") === "ERP") {
      sessionStorage.clear();
      window.location.href = "https://ieerp.iecsl.in/Dashboard";
    } else {
      sessionStorage.clear();
      navigate("/login");
    }
  };

  return (
    <div className="top-navbar">
      <div className="navbar-left">
        <button
          className="sidebar-toggle-btn"
          onClick={onSidebarToggle}
          aria-label={sidebarCollapsed ? "Open sidebar" : "Collapse sidebar"}
          title={sidebarCollapsed ? "Open sidebar" : "Collapse sidebar"}
        >
          <MenuIcon style={{ fontSize: '32px' }} />
        </button>
        <div className="navbar-company-info">
          <div className="navbar-company-title">MENDINE PHARMACEUTICALS PVT LTD</div>
          <div className="navbar-company-date">{formattedDate}</div>
        </div>
      </div>

      {/* 👇 CLICKABLE USER SECTION */}

      {/* new 21 */}
      <div className="navbar-right">
        <div className="navbar-user" onClick={handleClick}>
          <span className="user-name">{userName}</span>
          <Avatar className="user-avatar" src={profileImage || undefined} sx={{ bgcolor: '#e2e8f0', color: '#1B1642' }}>
            {!profileImage && getInitials(userName)}
          </Avatar>
        </div>
      </div>

      {/* 👇 DROPDOWN MENU */}
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 3,
          sx: {
            mt: 1.5,
            borderRadius: 3,
            minWidth: 280,
            padding: '8px',
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.1)',
          },
        }}
      >
        <div className="profile-dropdown-header">
          <Avatar
            className="profile-dropdown-avatar"
            src={profileImage || undefined}
            sx={{ bgcolor: '#e2e8f0', color: '#1B1642' }}
          >
            {!profileImage && getInitials(userName)}
          </Avatar>
          <div className="profile-dropdown-info">
            <span className="profile-dropdown-name">{userName}</span>
            <span className="profile-dropdown-email">{sessionStorage.getItem("userEmail") || "user@example.com"}</span>
          </div>
        </div>

        <Divider sx={{ my: 1 }} />

        {/* <MenuItem onClick={() => navigate("/profile")} sx={{ borderRadius: 2, mb: 0.5, py: 1 }}>
          <ListItemIcon>
            <PersonIcon fontSize="small" sx={{ color: '#1B1642' }} />
          </ListItemIcon>
          <span style={{ color: '#1B1642', fontWeight: 500 }}>View Profile</span>
        </MenuItem> */}

        {/* <MenuItem onClick={() => navigate("/change-password")} sx={{ borderRadius: 2, mb: 1, py: 1 }}>
          <ListItemIcon>
            <LockIcon fontSize="small" sx={{ color: '#1B1642' }} />
          </ListItemIcon>
          <span style={{ color: '#1B1642', fontWeight: 500 }}>Change Password</span>
        </MenuItem> */}

        <MenuItem
          onClick={handleLogout}
          sx={{
            borderRadius: 2,
            backgroundColor: '#FEF2F2',
            color: '#EF4444',
            '&:hover': { backgroundColor: '#FEE2E2' },
            py: 1.2,
            mt: 1
          }}
        >
          <ListItemIcon>
            <LogoutIcon fontSize="small" sx={{ color: '#EF4444' }} />
          </ListItemIcon>
          <span style={{ fontWeight: 600, fontSize: '0.95rem' }}>{buttonText}</span>
        </MenuItem>
      </Menu>
    </div>
  );
}

export default Navbar;
